import React from 'react';
import PropTypes from 'prop-types';
import { openAppUrl } from '../../../../../modules/appStore';

import {
  BodyText,
  Button,
  Icon,
  Modal,
  Stack,
} from '../../../../ui';

import useMount from '../../../../../hooks/useMount';

import analytics from '../../../../../modules/analytics';

import LOGO from '../../../../../../images/styleseat_ios_appicon_360.png';

const ImportContactsModal = ({
  onClose,
}) => {
  const handleDownloadApp = () => {
    openAppUrl();
    onClose();
  };

  useMount(() => analytics.track('pro_import_contacts_modal_viewed'));

  return (
    <Modal>
      <Stack space={16} justifyContent="center" alignItems="center" paddingY={8}>
        <Icon uri={LOGO} size={96} />
        <BodyText
          appearance="large"
          textAlign="center"
          style={{ width: '225px' }}
        >
          Import contacts straight from your device
        </BodyText>
        <Stack space={4} paddingX={40}>
          <Button
            appearance="primary"
            onClick={handleDownloadApp}
            clickTracking="pro_import_contacts_modal_download_clicked"
            testID="import-contacts-download"
            style={{ width: '140px' }}
          >
            Download App
          </Button>
          <Button
            appearance="text-light"
            onClick={onClose}
            clickTracking="pro_import_contacts_modal_dismiss_clicked"
            testID="import-contacts-dismiss"
            style={{ width: '140px' }}
          >
            Maybe Later
          </Button>
        </Stack>
      </Stack>
    </Modal>
  );
};

ImportContactsModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default ImportContactsModal;
